import ApprovalListViewModel from "../../common/approvalListViewModel";
import RefundApprovalType from "entities/refundApprovalType";
import type { IRefund } from "entities/types";
import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import type RefundsSearchFilter from "entities/filters/refunds/refundsSearchFilter";
import type RefundType from "entities/refundType";
import type LicensePlate from "entities/licensePlate";
import type TransferOriginalPayment from "entities/transferOriginalPaymentDetailResponse";
import { bound } from "@frui.ts/helpers";
import { Modules } from "config";

export default abstract class RefundForRefundOfRefundsListViewModel<
  TEntity extends IRefund,
  TDetail extends ScreenBase,
  TFilter extends RefundsSearchFilter
> extends ApprovalListViewModel<RefundApprovalType, TEntity, TDetail, TFilter> {
  abstract readonly refundType: RefundType;
  readonly approvalType = RefundApprovalType;

  translateModelAttribute(model: "licensePlate", attribute: keyof LicensePlate): string;
  translateModelAttribute(model: "refund", attribute: keyof IRefund): string;
  translateModelAttribute(model: "transferOriginalPayment", attribute: keyof TransferOriginalPayment): string;
  translateModelAttribute(
    model: "licensePlate" | "refund" | "transferOriginalPayment",
    attribute: keyof LicensePlate | keyof IRefund | keyof TransferOriginalPayment
  ) {
    return this.localizationService.translateAttribute(model, attribute);
  }

  @bound
  canApprove(item: TEntity) {
    return item.permittedActions.approval.isAllowed && super.canApprove(item);
  }

  @bound
  translateModuleGeneral(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `refundForRefundOfRefunds.${code}`, size);
  }
}
